// src/components/layout/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Role check — check both cognito:groups and custom:role attribute
    if (roles && roles.length > 0) {
        const userGroups = user?.groups || [];
        const userRole = user?.role || user?.attributes?.['custom:role'] || 'student';
        
        const userHasRequiredRole = roles.some(role => 
            userGroups.includes(role) || userRole.toLowerCase() === role.toLowerCase()
        );

        if (!userHasRequiredRole) {
            return <Navigate to="/404" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
